import React, { useEffect } from 'react';
import { MdErrorOutline } from 'react-icons/md';

import { Flex } from '../components/common/atom/Layout';
import { Text } from '../components/common/atom/Text';

const NotFoundPage = ({ history }) => {
  useEffect(() => {
    const goBackPrevUrl = setTimeout(() => history.goBack(), 1500);
    return () => clearTimeout(goBackPrevUrl);
  }, []);

  return (
    <Flex column height="50vh">
      <MdErrorOutline size={60} />
      <Text
        size={20}
        style={{ marginTop: '2.5rem' }}
        lineHeight={2}
        textAlign="center"
      >
        존재하지 않는 페이지입니다.
        <br />
        이전 페이지로 이동됩니다.
      </Text>
    </Flex>
  );
};

export default React.memo(NotFoundPage);
